import DefaultValidation from '@/services/validations/DefaultValidation';
import { isNull } from '@/functions/Util';

export default class FlexLancamentoValidation extends DefaultValidation {
    validate(flexLancamento, refs) {
        let validated = true;

        if(isNull(flexLancamento.idMotivo)) {
            refs.motivoSelected.focusedOut = true;
            validated = false;
        }
        
        if(isNull(flexLancamento.observacao) && refs.observacaoInput.required) {
            refs.observacaoInput.focusedOut = true;
            validated = false;
        }

        if (isNull(flexLancamento.saldoGerado)) {
            refs.valorInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}
